<template>
  <!-- 综合数据 ---柱状图 -->
  <div>
    <div ref="chartRef" style="width: 800px; height: 400px"></div>
  </div>
</template>

<script setup>
import * as echarts from "echarts";
import { ref, reactive, onMounted } from "vue";
let chartInstance;
const chartRef = ref(null);
const option = {
  // 定义每根柱子的颜色
  color: [
    "#f79646",
    "#46f7d1",
    "#f7464a",
    "#46f771",
    "#467df7",
    "#f7e646",
    "#9646f7",
    "#f7469a",
    "#46a6f7",
  ],
  xAxis: {
    type: "category",
    data: [
      "抑郁",
      "应激",
      "身体",
      "精神",
      "睡眠",
      "抵抗力",
      "集中力",
      "左右脑均衡",
      "行为倾向",
    ],
    axisLabel: {
      interval: 0, // 强制显示所有标签
      textStyle: {
        fontSize: 12, // 字体大小
        color: "#65BCEA", // 字体颜色
      },
    },
    axisLine: {
      show: false, // 隐藏 x 轴的线条
    },
    axisTick: {
      show: false, // 隐藏刻度线
    },
  },
  yAxis: {
    type: "value",
    axisLabel: {
      show: true, // 显示刻度标签
      textStyle: {
        fontSize: 12, // 刻度字体大小
        color: "#65BCEA", // 刻度字体颜色
      },
    },
    axisLine: {
      show: false, // 不显示 Y 轴线
    },
    splitLine: {
      show: false, // 不显示 Y 轴线
    },
  },
  series: [
    // 背景柱子
    {
      data: [200, 200, 200, 200, 200, 200, 200, 200, 200], // 背景柱子的最大值
      type: "bar",
      barWidth: 15, // 比前景柱子更宽
      itemStyle: {
        color: "rgba(200, 200, 200, 0.2)", // 背景柱子的颜色
        borderRadius: [50, 50, 50, 50], // 设置圆角，与前景一致
      },
      silent: true, // 禁用鼠标事件
    },
    // 前景柱子
    {
      data: [
        {
          value: 120,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#FCE4B0" }, // 浅色
              { offset: 1, color: "#F9BD55" }, // 深色
            ]),
          },
        },
        {
          value: 200,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#FFA796" }, // 浅色
              { offset: 1, color: "#FF5D43" }, // 深色
            ]),
          },
        },
        {
          value: 150,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#B2DFFF" }, // 浅色
              { offset: 1, color: "#66BFFE" }, // 深色
            ]),
          },
        },
        {
          value: 80,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#FCD2B0" }, // 浅色
              { offset: 1, color: "#F58140" }, // 深色
            ]),
          },
        },
        {
          value: 70,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#FCD3B1" }, // 浅色
              { offset: 1, color: "#F58342" }, // 深色
            ]),
          },
        },
        {
          value: 110,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#A8ECDC" }, // 浅色
              { offset: 1, color: "#3DCDAE" }, // 深色
            ]),
          },
        },
        {
          value: 130,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#A8EADF" }, // 浅色
              { offset: 1, color: "#3ECEAF" }, // 深色
            ]),
          },
        },
        {
          value: 89,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#B7DFFF" }, // 浅色
              { offset: 1, color: "#61BAFE" }, // 深色
            ]),
          },
        },
        {
          value: 20,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#A8ECD8" }, // 浅色
              { offset: 1, color: "#42CFB1" }, // 深色
            ]),
          },
        },
      ],
      type: "bar",
      itemStyle: {
        borderRadius: [50, 50, 50, 50], // 设置柱子圆角，左上、右上、右下、左下
      },
      barWidth: 15, // 柱子宽度
      barGap: "-100%", // 柱子间距
      label: {
        show: true, // 显示顶部数据标签
        position: "top", // 标签显示在顶部
        formatter: (params) => {
          return `{labelColor|${params.value}}`; // 使用 rich 定义颜色样式
        },
        rich: {
          labelColor: {
            color: (params) => params.data.itemStyle.color, // 从柱子的颜色获取对应的颜色
            fontSize: 12,
          },
        },
      },
    },
  ],
};

const init = () => {
  chartInstance = echarts.init(chartRef.value);
  option && chartInstance.setOption(option);
};
onMounted(() => {
  init();
});
</script>

<style scoped></style>
